var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBinanceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 91,
    viewBox: "0 0 91 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_6948_102098)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 45.5,
    cy: 49.405,
    rx: 40,
    ry: 39.9988,
    fill: "#F3BA2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5532 44.494L45.5055 32.5469L57.4627 44.5037L64.4134 37.5484L45.5055 18.6362L26.5977 37.5435L33.5532 44.494Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7305 49.4067L21.6835 42.4539L28.6365 49.4067L21.6835 56.3595L14.7305 49.4067Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5532 54.3174L45.5055 66.2693L57.4626 54.3125L64.4182 61.2581L64.4133 61.263L45.5055 80.1751L26.5976 61.2727L26.5879 61.263L33.5532 54.3174Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.3633 49.4082L69.3163 42.4554L76.2693 49.4082L69.3163 56.361L62.3633 49.4082Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.5586 49.4026L45.5059 42.3452L40.2904 47.5605L39.6877 48.1584L38.4531 49.3929L38.4434 49.4026L38.4531 49.4172L45.5059 56.4649L52.5586 49.4075L52.5635 49.4026H52.5586Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_6948_102098",
    x: 0.5,
    y: 0.40625,
    width: 90,
    height: 90,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_6948_102098"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6948_102098"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6948_102098",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBinanceIcon);
export default __webpack_public_path__ + "static/media/binance-icon.5b328aae9793654c6ae11e12d2bdebea.svg";
export { ForwardRef as ReactComponent };